module.exports = __webpack_public_path__ + "img/mind_skeleton_time_11.583336ca.png";